<template>
  <el-dialog
      title="上传报告"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="handleClose"
      class="upload-report-dialog"
  >
    <div v-if="currentClass">
      <div style="margin-bottom: 20px; padding: 12px; background: #f5f7fa; border-radius: 4px;">
        <div style="margin-bottom: 5px;">
          <span style="color: #909399;">{{ tabType === 'students' ? '学生:' : '班级:' }}</span>
          <span style="font-weight: bold; color: #303133;"> {{ displayName }}</span>
        </div>
      </div>

      <!-- 文件上传区域 -->
      <div class="upload-area" @click="triggerFileInput" @dragover.prevent @drop="handleDrop">
        <input
            ref="fileInput"
            type="file"
            style="display: none"
            accept=".doc,.docx,.pdf"
            @change="handleFileSelect"
        />

        <div v-if="!currentFile" class="upload-placeholder">
          <i class="el-icon-upload" style="font-size: 48px; color: #C0C4CC; margin-bottom: 16px;"></i>
          <div class="upload-text">
            <div style="font-size: 14px; color: #606266; margin-bottom: 4px;">
              点击或拖拽文件到此区域
            </div>
            <div style="font-size: 12px; color: #909399;">
              支持 .doc .docx .pdf 格式，不超过10MB
            </div>
          </div>
        </div>

        <div v-else class="file-info">
          <div style="display: flex; align-items: center;">
            <i class="el-icon-document" style="font-size: 20px; color: #409EFF; margin-right: 8px;"></i>
            <div style="flex: 1; min-width: 0;">
              <div style="font-weight: 500; color: #303133; margin-bottom: 4px; word-break: break-all;">
                {{ currentFile.name }}
              </div>
              <div style="font-size: 12px; color: #909399;">
                {{ formatFileSize(currentFile.size) }}
              </div>
            </div>
            <el-button
                v-if="!uploading && !ossFileInfo.url"
                type="text"
                icon="el-icon-delete"
                @click.stop="removeFile"
                style="margin-left: 8px;"
            ></el-button>
          </div>

          <!-- 上传进度 -->
          <div v-if="uploading" style="margin-top: 12px;">
            <el-progress
                :percentage="uploadProgress"
                :stroke-width="6"
                :show-text="false"
                color="#409EFF"
            ></el-progress>
            <div style="text-align: center; color: #606266; font-size: 12px; margin-top: 4px;">
              上传中 {{ uploadProgress }}%
            </div>
          </div>

          <!-- 上传成功 -->
          <div v-if="ossFileInfo.url"
               style="margin-top: 12px; padding: 8px; background: #f0f9eb; border-radius: 4px; border: 1px solid #e1f3d8;">
            <div style="display: flex; align-items: center; color: #67c23a;">
              <i class="el-icon-success" style="font-size: 14px; margin-right: 6px;"></i>
              <span style="font-size: 12px;">文件上传成功</span>
            </div>
          </div>

          <!-- 上传失败 -->
          <div v-if="uploadError" style="margin-top: 12px;">
            <el-alert
                :title="uploadError"
                type="error"
                :closable="true"
                @close="uploadError = ''"
                show-icon
                style="padding: 6px 12px;"
            ></el-alert>
          </div>
        </div>
      </div>

      <!-- 上传按钮 -->
      <div v-if="currentFile && !ossFileInfo.url && !uploading" style="margin-top: 20px; text-align: center;">
        <el-button
            type="primary"
            @click="uploadToOSS"
            :loading="uploading"
            :disabled="uploading"
            style="width: 200px;"
        >
          开始上传
        </el-button>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button
          type="success"
          @click="handleConfirm"
          :loading="saving"
          :disabled="!ossFileInfo.url || saving"
      >
        {{ saving ? '保存中...' : '确认上传' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {fileUploadStorageConfig, uploadClassAi, uploadstudentsAi} from '@/api/teacher'

export default {
  name: 'UploadReportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentClass: {
      type: Object,
      default: () => ({})
    },
    currentStudents: {
      type: Object,
      default: () => ({})
    },
    userId: {
      type: [Number, String],
      default: ''
    },
    zhid: {
      type: [Number, String],
      default: ''
    },
    bjid: {
      type: [Number, String],
      default: ''
    },
    jxid: {
      type: [Number, String],
      default: ''
    },
    xsid: {
      type: [Number, String],
      default: ''
    },
    tabType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      currentFile: null,
      ossConfig: null,
      uploading: false,
      saving: false,
      uploadProgress: 0,
      uploadError: '',

      ossFileInfo: {
        url: '',
        fileName: '',
        fileSize: 0,
        ossKey: ''
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.dialogVisible = newVal
        if (newVal) {
          this.initOSSConfig()
        }
      }
    }
  },
  computed: {
    displayName() {
      if (this.tabType === 'students') {
        return this.currentStudents ? this.currentStudents.xsxm : ''
      } else {
        return this.currentClass ? this.currentClass.bjmc : ''
      }
    }
  },
  methods: {
    // 初始化OSS配置
    async initOSSConfig() {
      try {
        this.resetState()

        const res = await fileUploadStorageConfig({
          zhid: sessionStorage.getItem("zhid"),
          zylxid: 2,
        })

        if (res?.result) {
          this.ossConfig = res.result
          console.log('OSS配置初始化成功')
        } else {
          throw new Error('获取上传配置失败')
        }
      } catch (error) {
        console.error('初始化OSS配置失败:', error)
        this.uploadError = '获取上传配置失败'
        this.$message.error('获取上传配置失败，请刷新重试')
      }
    },

    // 重置状态
    resetState() {
      this.currentFile = null
      this.uploading = false
      this.saving = false
      this.uploadProgress = 0
      this.uploadError = ''
      this.ossFileInfo = {
        url: '',
        fileName: '',
        fileSize: 0,
        ossKey: ''
      }
    },

    triggerFileInput() {
      if (!this.currentFile && !this.uploading) {
        this.$refs.fileInput.click()
      }
    },

    handleFileSelect(event) {
      const file = event.target.files[0]
      if (file) {
        this.validateAndSetFile(file)
      }
    },

    handleDrop(event) {
      event.preventDefault()
      if (this.currentFile || this.uploading) return

      const file = event.dataTransfer.files[0]
      if (file) {
        this.validateAndSetFile(file)
      }
    },

    validateAndSetFile(file) {
      // 验证文件类型
      const extension = file.name.split('.').pop().toLowerCase()
      const isValidType = ['doc', 'docx','pdf'].includes(extension)

      if (!isValidType) {
        this.$message.error('只能上传 .doc 或 .docx .pdf格式文件')
        return false
      }

      // 验证文件大小
      const maxSize = 10 * 1024 * 1024 // 10MB
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10MB')
        return false
      }

      this.currentFile = file
      this.uploadError = ''
      return true
    },

    removeFile() {
      this.currentFile = null
      this.uploadError = ''
      this.$refs.fileInput.value = ''
    },

    async uploadToOSS() {
      if (!this.currentFile || !this.ossConfig) {
        this.uploadError = '文件或配置信息缺失'
        return
      }

      this.uploading = true
      this.uploadProgress = 0
      this.uploadError = ''

      try {
        const timestamp = Date.now()
        const randomStr = Math.random().toString(36).substr(2, 8)
        const originalName = this.currentFile.name.replace(/\.[^/.]+$/, '')
        const safeName = originalName.replace(/[^\u4e00-\u9fa5a-zA-Z0-9_-]/g, '_')
        const extension = this.currentFile.name.split('.').pop().toLowerCase()
        const newFileName = `${safeName}_${timestamp}_${randomStr}.${extension}`

        const ossKey = `docs/${this.zhid || 'temp'}/${newFileName}`

        const formData = new FormData()
        formData.append('key', ossKey)
        formData.append('policy', this.ossConfig.policy || '')
        formData.append('OSSAccessKeyId', this.ossConfig.accessKeyId || '')
        formData.append('signature', this.ossConfig.signature || '')
        formData.append('success_action_status', '200')

        if (this.ossConfig.callBack) {
          formData.append('callback', this.ossConfig.callBack)
        }

        formData.append('file', this.currentFile)

        const uploadUrl = this.ossConfig.host || 'https://wlkt-repo.oss-cn-shanghai.aliyuncs.com'

        const xhr = new XMLHttpRequest()

        xhr.upload.addEventListener('progress', (event) => {
          if (event.lengthComputable) {
            this.uploadProgress = Math.round((event.loaded * 100) / event.total)
          }
        })

        const uploadPromise = new Promise((resolve, reject) => {
          xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                try {
                  // 解析响应
                  const responseText = xhr.responseText
                  let fileUrl = ''

                  if (responseText) {
                    const parser = new DOMParser()
                    const xmlDoc = parser.parseFromString(responseText, "text/xml")
                    const location = xmlDoc.getElementsByTagName('Location')[0]
                    if (location?.textContent) {
                      fileUrl = location.textContent
                    }
                  }

                  if (!fileUrl) {
                    fileUrl = `${uploadUrl}/${ossKey}`
                  }

                  resolve({
                    url: fileUrl,
                    ossKey,
                    fileName: this.currentFile.name,
                    fileSize: this.currentFile.size
                  })
                } catch (error) {
                  resolve({
                    url: `${uploadUrl}/${ossKey}`,
                    ossKey,
                    fileName: this.currentFile.name,
                    fileSize: this.currentFile.size
                  })
                }
              } else {
                let errorMsg = '上传失败'
                if (xhr.responseText) {
                  try {
                    const parser = new DOMParser()
                    const xmlDoc = parser.parseFromString(xhr.responseText, "text/xml")
                    const errorElement = xmlDoc.getElementsByTagName('Message')[0]
                    if (errorElement?.textContent) {
                      errorMsg = errorElement.textContent
                    }
                  } catch (e) {
                    errorMsg = xhr.responseText || '上传失败'
                  }
                }
                reject(new Error(errorMsg))
              }
            }
          }

          xhr.onerror = () => {
            reject(new Error('网络错误，请检查网络连接'))
          }

          xhr.open('POST', uploadUrl)
          xhr.send(formData)
        })

        const result = await uploadPromise

        this.ossFileInfo = {
          url: result.url,
          ossKey: result.ossKey,
          fileName: result.fileName,
          fileSize: result.fileSize
        }

        this.$message.success('文件上传成功')

      } catch (error) {
        console.error('上传失败:', error)
        this.uploadError = error.message || '文件上传失败'
        this.$message.error(this.uploadError)
      } finally {
        this.uploading = false
      }
    },

    async handleConfirm() {
      if (!this.ossFileInfo.url) {
        this.$message.warning('请先上传文件')
        return
      }
      console.log(this.ossFileInfo, 9999)
      this.saving = true

      try {

        if (this.tabType === 'students') {
          const saveData = {
            bgdz: this.ossFileInfo.url,
            cjr: this.userId,
            xgr: this.userId,
            xsid: this.xsid,
            bjid: this.bjid,
            jxid: this.jxid
          }
          const res = await uploadstudentsAi(saveData)
          if (res.resultCode === 200) {
            this.$message.success('报告上传成功')
            this.saving = false
            this.$parent.getGradeList()
            // this.$emit('success', {
            //   ...saveData,
            //   reportId: res.data?.reportId || res.result?.id
            // })
            this.$emit('close')
          } else {
            this.$message.error(res?.message || '保存报告信息失败')
          }
        } else {
          const saveData = {
            bgdz: this.ossFileInfo.url,
            cjr: this.userId,
            xgr: this.userId,
            bjid: this.bjid,
            jxid: this.jxid
          }
          const res = await uploadClassAi(saveData)
          if (res.resultCode === 200) {
            this.$message.success('报告上传成功')
            this.saving = false
            this.$parent.getClassList()
            // this.$emit('success', {
            //   ...saveData,
            //   reportId: res.data?.reportId || res.result?.id
            // })
            this.$emit('close')
          } else {
            this.$message.error(res?.message || '保存报告信息失败')
          }
        }


      } catch (error) {
        console.error('保存报告信息失败:', error)
        this.$message.error('保存报告信息失败，请稍后重试')
      } finally {
        this.saving = false
      }
    },

    handleCancel() {
      this.$emit('close')
    },

    handleClose() {
      this.resetState()
      this.$emit('close')
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-report-dialog {
  :deep(.el-dialog__body) {
    padding: 20px;
  }
}

.upload-area {
  border: 2px dashed #dcdfe6;
  border-radius: 6px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #409EFF;
    background-color: #f5f7fa;
  }

  &.drag-over {
    border-color: #409EFF;
    background-color: #ecf5ff;
  }
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #606266;
}

.upload-text {
  text-align: center;
}

.file-info {
  width: 100%;
  padding: 0 10px;
}

.dialog-footer {
  .el-button {
    min-width: 80px;
  }

  .el-button + .el-button {
    margin-left: 10px;
  }
}
</style>
